import DashboardHeader from '../../features/dahsboards/header/DashboardHeader'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { DashboardId } from '../../shared/models/id/dashboard-id'
import SimpleIndicator from '../../features/dahsboards/panel/chart-helpers/simple-indicator/SimpleIndicator'
import { Icons, IconSize, ThresholdOperator } from '../../shared/models/panel'
import { Pie } from 'react-chartjs-2'
import { useAppSelector } from '../../store/store'

const aliasSingleValue = {
  extrudeuse: {
    name: 'E1',
    description: 'E1',
    config: {},
    dashboardID: new DashboardId(''),
  },
  extrudeuse2: {
    name: 'E1',
    description: 'E1',
    config: {},
    dashboardID: new DashboardId(''),
  },
  extrudeuse3: {
    name: 'E1',
    description: 'E1',
    config: {},
    dashboardID: new DashboardId(''),
  },
}

const aggregateSingleValue = {
  extrudeuse: {
    datasource: {},
    data: {},
  },
}

const DashboardTest = () => {
  const { theme } = useAppSelector((state) => state.settings)
  return (
    <div>
      <DashboardHeader title={'Extrudeuses B3'} />
      <Row className={'pt-2'}>
        <Col md={4}>
          <SimpleIndicator
            label={'Extrudeuse 1'}
            value={{
              value: 'Production',
              ts: 123456,
            }}
            config={{
              iconSize: IconSize['5x'],
              showLabel: true,
              showValue: true,
              thresholds: [
                {
                  color: 'green',
                  reference: 'Production',
                  operator: ThresholdOperator.EQUAL,
                  icon: Icons.CIRCLE_CHECKMARK,
                },
              ],
            }}
          />
        </Col>
        <Col md={4}>
          <SimpleIndicator
            label={'Extrudeuse 2'}
            value={{
              value: 'Chauffe',
              ts: 123456,
            }}
            config={{
              iconSize: IconSize['5x'],
              showLabel: true,
              showValue: true,
              thresholds: [
                {
                  color: 'orange',
                  reference: 'Chauffe',
                  operator: ThresholdOperator.EQUAL,
                  icon: Icons.CIRCLE_CHECKMARK,
                },
              ],
            }}
          />
        </Col>
        <Col md={4}>
          <SimpleIndicator
            label={'Extrudeuse 3'}
            value={{
              value: 'Arrêt',
              ts: 123456,
            }}
            config={{
              iconSize: IconSize['5x'],
              showLabel: true,
              align: 'right',
              showValue: true,
              thresholds: [
                {
                  color: 'red',
                  reference: 'Arrêt',
                  operator: ThresholdOperator.EQUAL,
                  icon: Icons.CIRCLE_XMARK,
                },
              ],
            }}
          />
        </Col>
      </Row>
      <Row className={'pt-2'}>
        <Col md={4}>
          <div className={'shadow-none border-2 card'}>
            <h3 className={'ps-3 pt-2'}>Répartition état Extrudeuse 1</h3>
            <Pie
              className={'m-4'}
              options={{
                responsive: true,
                maintainAspectRatio: true,
                plugins: {
                  legend: {
                    display: true,
                    labels: {
                      color: theme === 'dark' ? 'white' : 'black',
                      font: {
                        size: 20,
                      },
                    },
                  },
                },
              }}
              data={{
                labels: [
                  'Production',
                  'Arrêt',
                  'Sous Production',
                  'Chauffe',
                  'Chauffe avec matière',
                ],
                datasets: [
                  {
                    label: 'My First Dataset',
                    data: [10, 45, 10, 20, 10],
                    backgroundColor: [
                      'rgb(29,179,11)',
                      'rgb(232,20,20)',
                      'rgb(239,98,12)',
                      'rgb(255, 205, 86)',
                      'rgb(223,172,38)',
                    ],
                    borderColor: 'transparent',
                    hoverOffset: 20,
                  },
                ],
              }}
            />
          </div>
        </Col>
        <Col md={4}>
          <div className={'shadow-none border-2 card'}>
            <h3 className={'ps-3 pt-2'}>Répartition état Extrudeuse 2</h3>
            <Pie
              className={'m-4'}
              options={{
                responsive: true,
                maintainAspectRatio: true,
                plugins: {
                  legend: {
                    display: true,
                    labels: {
                      color: theme === 'dark' ? 'white' : 'black',
                      font: {
                        size: 20,
                      },
                    },
                  },
                },
              }}
              data={{
                labels: [
                  'Production',
                  'Arrêt',
                  'Sous Production',
                  'Chauffe',
                  'Chauffe avec matière',
                ],
                datasets: [
                  {
                    label: 'My First Dataset',
                    data: [20, 5, 10, 5, 10],
                    backgroundColor: [
                      'rgb(29,179,11)',
                      'rgb(232,20,20)',
                      'rgb(239,98,12)',
                      'rgb(255, 205, 86)',
                      'rgb(223,172,38)',
                    ],
                    borderColor: 'transparent',
                    hoverOffset: 20,
                  },
                ],
              }}
            />
          </div>
        </Col>
        <Col md={4}>
          <div className={'shadow-none border-2 card'}>
            <h3 className={'ps-3 pt-2'}>Répartition état Extrudeuse 3</h3>
            <Pie
              className={'m-4'}
              options={{
                responsive: true,
                maintainAspectRatio: true,
                plugins: {
                  legend: {
                    display: true,
                    labels: {
                      color: theme === 'dark' ? 'white' : 'black',
                      font: {
                        size: 20,
                      },
                    },
                  },
                },
              }}
              data={{
                labels: [
                  'Production',
                  'Arrêt',
                  'Sous Production',
                  'Chauffe',
                  'Chauffe avec matière',
                ],
                datasets: [
                  {
                    label: 'My First Dataset',
                    data: [20, 30, 10, 20, 10],
                    backgroundColor: [
                      'rgb(29,179,11)',
                      'rgb(232,20,20)',
                      'rgb(239,98,12)',
                      'rgb(255, 205, 86)',
                      'rgb(223,172,38)',
                    ],
                    borderColor: 'transparent',
                    hoverOffset: 20,
                  },
                ],
              }}
            />
          </div>
        </Col>
      </Row>
      <Row className={'pt-2'}>
        <Col md={4}>
          <div className={'shadow-none border-2 card'}>
            <h3 className={'ps-3 pt-2'}>Tarfication Extrudeuse 1</h3>
            <Pie
              className={'m-4'}
              options={{
                responsive: true,
                maintainAspectRatio: true,
                plugins: {
                  legend: {
                    display: true,
                    labels: {
                      color: theme === 'dark' ? 'white' : 'black',
                      font: {
                        size: 20,
                      },
                    },
                  },
                },
              }}
              data={{
                labels: ['Heure Creuse', 'Heure pleine', 'Pic'],
                datasets: [
                  {
                    label: 'My First Dataset',
                    data: [10, 45, 10],
                    backgroundColor: [
                      'rgb(29,179,11)',
                      'rgb(239,98,12)',
                      'rgb(232,20,20)',
                    ],
                    borderColor: 'transparent',
                    hoverOffset: 20,
                  },
                ],
              }}
            />
          </div>
        </Col>
        <Col md={4}>
          <div className={'shadow-none border-2 card'}>
            <h3 className={'ps-3 pt-2'}>Tarfication Extrudeuse 2</h3>
            <Pie
              className={'m-4'}
              options={{
                responsive: true,
                maintainAspectRatio: true,
                plugins: {
                  legend: {
                    display: true,
                    labels: {
                      color: theme === 'dark' ? 'white' : 'black',
                      font: {
                        size: 20,
                      },
                    },
                  },
                },
              }}
              data={{
                labels: ['Heure Creuse', 'Heure pleine', 'Pic'],
                datasets: [
                  {
                    label: 'My First Dataset',
                    data: [20, 5, 10],
                    backgroundColor: [
                      'rgb(29,179,11)',
                      'rgb(239,98,12)',
                      'rgb(232,20,20)',
                    ],
                    borderColor: 'transparent',
                    hoverOffset: 20,
                  },
                ],
              }}
            />
          </div>
        </Col>
        <Col md={4}>
          <div className={'shadow-none border-2 card'}>
            <h3 className={'ps-3 pt-2'}>Tarfication Extrudeuse 3</h3>
            <Pie
              className={'m-4'}
              options={{
                responsive: true,
                maintainAspectRatio: true,
                plugins: {
                  legend: {
                    display: true,
                    labels: {
                      color: theme === 'dark' ? 'white' : 'black',
                      font: {
                        size: 20,
                      },
                    },
                  },
                },
              }}
              data={{
                labels: ['Heure Creuse', 'Heure pleine', 'Pic'],
                datasets: [
                  {
                    label: 'My First Dataset',
                    data: [20, 30, 10],
                    backgroundColor: [
                      'rgb(29,179,11)',
                      'rgb(239,98,12)',
                      'rgb(232,20,20)',
                    ],
                    borderColor: 'transparent',
                    hoverOffset: 20,
                  },
                ],
              }}
            />
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default DashboardTest
